import type { TokenStorage } from '../client.js';

const KEY = 'trackizy_token';

/**
 * Web TokenStorage — mirrors the remember-me behavior of src/lib/trackizy.js:
 *   remember=true  → localStorage (survives browser restart)
 *   remember=false → sessionStorage (wiped on tab close)
 *   remember omitted → preserve existing placement (default: localStorage)
 */
export function createWebTokenStorage(): TokenStorage {
  return {
    get() {
      return localStorage.getItem(KEY) ?? sessionStorage.getItem(KEY);
    },
    set(token, opts) {
      if (token === null) {
        localStorage.removeItem(KEY);
        sessionStorage.removeItem(KEY);
        return;
      }
      const remember =
        typeof opts?.remember === 'boolean'
          ? opts.remember
          : !sessionStorage.getItem(KEY);
      if (remember) {
        localStorage.setItem(KEY, token);
        sessionStorage.removeItem(KEY);
      } else {
        sessionStorage.setItem(KEY, token);
        localStorage.removeItem(KEY);
      }
    },
  };
}
